<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="permissoes"
        :headers="headers"
        :rotina-id="ID_TELA_DE_PERMISSOES"
        :loading="loading"
        @create="() => abrirDialogCriarPermissao()"
        @update="(indice) => abrirDialogEditarPermissao(indice)"
        @configure="(indice) => abrirDialogConfigurarPermissao(indice)"
        @delete="(indice) => abrirDialogExcluirPermissao(indice)"
      />
      <DialogDeEdicaoDePermissao
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :permissao="permissaoEdicaoParam"
        :itens="itensParam"
        @confirmado="atualizarPermissao"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogExcluirPermissao" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="itemPermissaoExclusao">
            Tem certeza que deseja excluir a permissão <b> {{ itemPermissaoExclusao.nome }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogExcluirPermissao = false"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" text @click="excluirPerfil">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <DialogDeConfiguracaoDePermissao
      :show-dialog-settings.sync="showDialogSettingsParam"
      :permissao="permissaoConfiguracaoParam"
    />
  </div>
</template>

<script>
import PermissaoService from '@/services/usuario/permissao'
import SnackbarMessage from '@/components/SnackbarMessage'
import DialogDeEdicaoDePermissao from '@/components/permissoes/DialogDeEdicaoDePermissao'
import DataTableDeCrud from '@/components/DataTableDeCrud'
import SnackBar from '@/models/components/snackbar'
import Perfil from '@/models/permissao'
import DialogDeConfiguracaoDePermissao from '@/components/permissoes/DialogDeConfiguracaoDePermissao.vue'
import { ID_TELA_DE_PERMISSOES } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDePermissao,
    DialogDeConfiguracaoDePermissao
  },
  data: () => ({
    name: 'TelaDePerfis',
    headers: [{ text: 'Nome', value: 'nome' }],
    permissoes: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    showDialogSettingsParam: false,
    permissaoEdicaoParam: new Perfil(),
    permissaoConfiguracaoParam: new Perfil(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogExcluirPermissao: false,
    itemPermissaoExclusao: new Perfil(),
    indicePerfilExclusao: 0,
    ID_TELA_DE_PERMISSOES: ID_TELA_DE_PERMISSOES
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        this.loadPerfis()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar permissoes cadastrados.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadPerfis() {
      this.loading = true
      const response = await PermissaoService.getAll()
      this.permissoes = response.map((item) => ({
        ...item
      }))
      this.loading = false
    },

    atualizarPermissao(permissao) {
      if (!permissao) return

      const indice = this.permissoes.findIndex(
        (permissaoExistente) => permissaoExistente.id === permissao.id
      )

      if (indice === -1) {
        this.permissoes.push(permissao)
        this.snackbar.snackTextParam = 'Permissão criada com sucesso.'
      } else {
        this.permissoes.splice(indice, 1, permissao)
        this.snackbar.snackTextParam = 'Permissão atualizada com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    abrirDialogExcluirPermissao(indice) {
      this.itemPermissaoExclusao = this.permissoes[indice]
      if (!this.itemPermissaoExclusao.id) return

      this.indicePerfilExclusao = indice
      this.dialogExcluirPermissao = true
    },

    async excluirPerfil() {
      try {
        await PermissaoService.deleteById(this.itemPermissaoExclusao.id)
        this.snackbar.snackTextParam = 'Permissão removida com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.permissoes.splice(this.indicePerfilExclusao, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogExcluirPermissao = false
    },

    abrirDialogCriarPermissao() {
      this.operacao = 'adicionar'
      this.itensParam = {}
      this.permissaoEdicaoParam = new Perfil()
      this.showDialogParam = true
    },

    abrirDialogEditarPermissao(indice) {
      this.operacao = 'editar'
      this.itensParam = {}
      this.permissaoEdicaoParam = { ...this.permissoes[indice] }
      this.showDialogParam = true
    },

    abrirDialogConfigurarPermissao(indice) {
      this.permissaoConfiguracaoParam = { ...this.permissoes[indice] }
      this.showDialogSettingsParam = true
    }
  }
}
</script>
